import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldLabel } from './FieldLabel';

interface VideoSettingsProps {
  durationOptions: number[];
  aspectRatioOptions: string[];
  durationSeconds: number;
  aspectRatio: string;
  onDurationChange: (value: number) => void;
  onAspectRatioChange: (value: string) => void;
}

export const VideoSettings: React.FC<VideoSettingsProps> = ({
  durationOptions,
  aspectRatioOptions,
  durationSeconds,
  aspectRatio,
  onDurationChange,
  onAspectRatioChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <div>
        <FieldLabel
          label={t('services.generateVideo.durationLabel')}
          description={t('services.generateVideo.durationHint')}
        />
        <ToggleButtonGroup
          exclusive
          fullWidth
          size="small"
          value={durationSeconds}
          onChange={(_event, next: number | null) => next && onDurationChange(next)}
        >
          {durationOptions.map((value) => (
            <ToggleButton key={value} value={value} className="normal-case">
              {t('services.generateVideo.seconds', { value })}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
      <div>
        <FieldLabel
          label={t('services.generateVideo.aspectRatioLabel')}
          description={t('services.generateVideo.aspectRatioHint')}
        />
        <ToggleButtonGroup
          exclusive
          fullWidth
          size="small"
          value={aspectRatio}
          onChange={(_event, next: string | null) => next && onAspectRatioChange(next)}
        >
          {aspectRatioOptions.map((value) => (
            <ToggleButton key={value} value={value}>
              {value}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </div>
    </div>
  );
};
